import { render, staticRenderFns } from "./settle-list.vue?vue&type=template&id=4fa8ab84&scoped=true"
import script from "./settle-list.vue?vue&type=script&lang=js"
export * from "./settle-list.vue?vue&type=script&lang=js"
import style0 from "./settle-list.vue?vue&type=style&index=0&id=4fa8ab84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8ab84",
  null
  
)

export default component.exports